import { useOrganizationList } from '@clerk/react';
import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import OrganizationCreate from '@/components/auth/create-organization';
import { PageMeta } from '@/components/page-meta';
import { ROUTES } from '@/utils/routes';

export const OrganizationListPage = () => {
  const { isLoaded, userMemberships, setActive } = useOrganizationList({
    userMemberships: {
      infinite: false,
      pageSize: 10,
    },
  });

  const memberships = userMemberships?.data ?? [];
  const firstOrganizationId = memberships[0]?.organization?.id;
  const hasOrganizations = memberships.length > 0;

  useEffect(() => {
    if (!isLoaded || !firstOrganizationId) {
      return;
    }

    void setActive({ organization: firstOrganizationId });
  }, [isLoaded, firstOrganizationId, setActive]);

  if (isLoaded && hasOrganizations) {
    return <Navigate to={ROUTES.ROOT} replace />;
  }

  return (
    <>
      <PageMeta title="Select or create organization" />
      <OrganizationCreate />
    </>
  );
};
